// extracted by mini-css-extract-plugin
module.exports = {"header":"blog-post-module--header--1APPQ","author":"blog-post-module--author--38GEp","content":"blog-post-module--content--c97Ib"};